var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuPolygon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 37,
  fill: "none",
  viewBox: "0 0 40 37"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.87 3.066c2.31-4 8.083-4 10.393 0l13.856 24c2.31 4-.577 9-5.196 9H6.21c-4.619 0-7.506-5-5.196-9z"
})));
export default SvgMenuPolygon;